// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'watch-solid';

export const Component = () => (
  <path d='M16.644 3.927H6.107c.24-.814.479-1.724.719-2.778C6.97.383 7.448 0 8.215 0h6.321c.766 0 1.245.383 1.389 1.15.24 1.053.479 1.962.719 2.777ZM6.826 23.372c.144.766.622 1.15 1.389 1.15h6.321c.766 0 1.245-.384 1.389-1.15.24-1.054.479-1.963.719-2.778H6.107c.24.814.479 1.724.719 2.778ZM19.709 6.848v3.928c.239 0 .479-.096.718-.288a.946.946 0 0 0 .288-.67V7.855a.977.977 0 0 0-.288-.72c-.239-.19-.479-.287-.718-.287Zm-2.443-1.963H5.486c-.432 0-.767.144-1.055.431A1.408 1.408 0 0 0 4 6.37v11.782c0 .43.144.766.431 1.053.288.288.623.432 1.054.432h11.781c.432 0 .767-.144 1.054-.432.288-.287.432-.622.432-1.053V6.37c0-.43-.144-.766-.432-1.054a1.408 1.408 0 0 0-1.054-.43Z' />
);

export const viewBox = '0 0 25 25';
